import { TherapyTypeEnum } from '@app/icare/entities/therapy/schema/TherapyType'
import { z } from 'zod'

export type PrescriberStatus = z.infer<typeof PrescriberStatusSchema>

export const PrescriberStatusSchema = z.object({
  active: z.boolean().nullish(),
  prescribesParentalNutrition: z.boolean().nullish().default(false),
  prescribesResources: z.boolean().nullish().default(false),
  therapies: z
    .array(z.enum(TherapyTypeEnum.$.zodEnum()))
    .nullish()
    .default(() => []),
})

export interface IsPrescriberEntity {
  prescriber: PrescriberStatus
}

export function isPrescriberEntity(val: unknown): val is IsPrescriberEntity {
  return typeof val === 'object' && val !== null && 'prescriber' in val
}
